import { Component, OnInit } from '@angular/core';
import {Globals} from '../../assets/shared/globals'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(public globals: Globals) { }

  ngOnInit() {
  }

}
